import {Component, ElementRef, OnInit, Renderer} from '@angular/core';
import {ApiService} from '../api.service';
import {ActivatedRoute} from '@angular/router';
import {Postcard} from '../postcard';
import {AuthService} from '../auth.service';
import {Location} from '@angular/common';
import {MatDialog, MatDialogRef, MatSnackBar} from '@angular/material';
import {ReportIssueComponent} from '../report-issue/report-issue.component';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-postcard',
  templateUrl: './postcard.component.html',
  styleUrls: ['./postcard.component.css']
})

export class PostcardComponent implements OnInit {

  public postcard: Postcard;
  public state = {LEFT: 'left', CENTER: 'center', RIGHT: 'right'};
  public padding = 24;
  public image = 'back';
  public card_width;
  public card_height;
  public current_scale = 1.0;
  public current_transform = null;
  public postcard_div;

  public reportDialog: MatDialogRef<ReportIssueComponent>;
  public reported = false;
  role = 'editor';

  // protected front_calculated = false;
  // protected back_calculated = false;
  // protected postcard_front_height;
  // protected postcard_front_width;
  // protected postcard_back_height;
  // protected postcard_back_width;

  constructor(public api: ApiService, public auth: AuthService, public route: ActivatedRoute, public el: ElementRef, private location: Location, private renderer: Renderer, private dialog: MatDialog, private reportSnackbar: MatSnackBar) {
    if (this.auth.isAuthenticated()) {
      this.role = JSON.parse(localStorage.getItem('user')).role;
    }

    this.route.params.subscribe(params =>
      this.api.getPostcard(params.id).subscribe(res => {
        this.postcard = res;
        this.postcard.postcard_image = environment.errors.imageBaseURL + this.postcard.postcard_back;
      }));
  }

  ngOnInit() {
  }

  calculateScale = function () {
    this.postcard_div = this.el.nativeElement.querySelector('#postcard').getBoundingClientRect();
    this.scale = this.postcard_div.width / this.postcard_div.height;

    this.card_width = this.el.nativeElement.querySelector('#postcard').getBoundingClientRect().width;
    this.card_height = this.el.nativeElement.querySelector('#postcard').getBoundingClientRect().height;
  };

  getPositionFromScale = function (scale) {
    return (this.card_width * scale - this.card_height) / 2;
  };

  rotate = function (direction) {
    this.direction = direction;
    this.resetImage();
  };

  switchImage = function () {
    // this.moved = false;

    if (this.image === 'back') {
      this.image = 'front';
      this.postcard.postcard_image = environment.errors.imageBaseURL + this.postcard.postcard_front;
    } else {
      this.image = 'back';
      this.postcard.postcard_image = environment.errors.imageBaseURL + this.postcard.postcard_back;
    }
  };

  resetImage = function () {
    let translate = '';
    if (this.state.LEFT === this.direction) {
      this.current_transform = `rotate(-90deg)`;
      this.current_scale = this.scale;
      translate = ` translateX(${-this.getPositionFromScale(this.scale)}px)`;
      this.renderer.setElementStyle(this.el.nativeElement.querySelector('#card_holder'), 'height', `${(this.card_width * this.scale - this.padding * 2)}px`);
      // this.renderer.setElementStyle(this.el.nativeElement.querySelector('#postcard'), 'transition-timing-function', 'ease-in');
    } else if (this.state.RIGHT === this.direction) {
      this.current_scale = this.scale;
      this.current_transform = `rotate(+90deg)`;
      translate = ` translateX(${this.getPositionFromScale(this.scale)}px)`;
      this.renderer.setElementStyle(this.el.nativeElement.querySelector('#card_holder'), 'height', `${(this.card_width * this.scale - this.padding * 2)}px`);
    } else {
      this.current_scale = 1.0;
      this.current_transform = `rotate(0deg)`;

      // if (!this.front_calculated) {
      //   this.front_calculated = true;
      //   this.postcard_front_height = this.el.nativeElement.querySelector('#postcard').getBoundingClientRect().height;
      //   this.postcard_front_width = this.el.nativeElement.querySelector('#postcard').getBoundingClientRect().width;
      // }
      //
      // if (!this.back_calculated) {
      //   this.back_calculated = true;
      //   this.postcard_back_height = this.el.nativeElement.querySelector('#postcard').getBoundingClientRect().height;
      //   this.postcard_back_width = this.el.nativeElement.querySelector('#postcard').getBoundingClientRect().width;
      // }
      //
      // console.log(this.postcard_back_height);
      // console.log(this.postcard_front_height);
      //
      // if (this.postcard_back_height === this.postcard_front_height) {
      //   console.log('we do nothing');
      // }


      // if (this.image === 'front' && this.postcard_back_height < this.postcard_front_height) {
      //   // console.log('we need to update this');
      //   console.log('one');
      //   console.log(this.postcard_back_height);
      //   console.log(this.postcard_front_height);
      //
      //   this.card_height = this.postcard_front_height;
      // }
      //
      // if (this.image === 'back' && this.postcard_front_height > this.postcard_back_height) {
      //   this.card_height = this.postcard_back_height;
      //   console.log('two');
      // }
      //
      // if (this.postcard_back_height)

      // if (this.image === 'back' && this.postcard_front_size < this.postcard_back_size) {
      //   console.log('we need to update this');
      // }

      // if (this.el.nativeElement.querySelector('#postcard').getBoundingClientRect().height < this.el.nativeElement.querySelector('#card_holder').getBoundingClientRect().height) {
      //   console.log('postcard smaller than card holder');
      //   this.card_height = this.el.nativeElement.querySelector('#postcard').getBoundingClientRect().height;
      // }
      //
      // if (this.el.nativeElement.querySelector('#postcard').getBoundingClientRect().height > this.el.nativeElement.querySelector('#card_holder').getBoundingClientRect().height) {
      //   console.log('postcard larger than card holder');
      //   this.card_height = this.el.nativeElement.querySelector('#postcard').getBoundingClientRect().height;
      // }

      // we need to recalculate the height for this image -> determines the bounding box for the image (allows to see the whole image from the beginning)
      // if (!this.moved) {
      //   // this.card_height = this.el.nativeElement.querySelector('#postcard').getBoundingClientRect().height;
      //   // this.card_height = this.el.nativeElement.querySelector('#postcard').getBoundingClientRect().height;
      //   this.moved = true;
      // }

      this.renderer.setElementStyle(this.el.nativeElement.querySelector('#card_holder'), 'height', `${this.card_height - this.padding * 2}px`);
    }
    this.renderer.setElementStyle(this.el.nativeElement.querySelector('#postcard'), 'transform', this.current_transform + translate + ` scale(${this.current_scale})`);
    this.renderer.setElementStyle(this.el.nativeElement.querySelector('#postcard'), 'transform-origin', '50% 50%');
  };

  moveImage = function ($event) {
    const scale = 2.5;
    const card_holder = this.el.nativeElement.querySelector('#card_holder').getBoundingClientRect();

    const mouseX = ($event.clientX - card_holder.left);
    const mouseY = ($event.clientY - card_holder.top);

    const mouseX_perc = (mouseX - card_holder.width / 2) / card_holder.width;
    const mouseY_perc = (mouseY - card_holder.height / 2) / card_holder.height;

    let translate, x_pos, y_pos, x_diff, y_diff;

    if (this.direction === this.state.RIGHT) {
      x_diff = (this.scale - scale) * this.card_width * -mouseY_perc;
      x_pos = 0 + this.getPositionFromScale(this.scale) - x_diff;
      y_diff = (this.scale - scale) * this.card_height * mouseX_perc;
      y_pos = 0 - y_diff;

    } else if (this.direction === this.state.LEFT) {
      x_diff = (this.scale - scale) * this.card_width * mouseY_perc;
      x_pos = 0 - this.getPositionFromScale(this.scale) - x_diff;
      y_diff = (this.scale - scale) * this.card_height * -mouseX_perc;
      y_pos = 0 - y_diff;
    } else {
      x_diff = (1 - scale) * this.card_width * -mouseX_perc;
      x_pos = 0 - x_diff;
      y_diff = (1 - scale) * this.card_height * -mouseY_perc;
      y_pos = 0 - y_diff;
    }

    translate = ` translate(${x_pos}px, ${y_pos}px) scale(${scale})`;
    this.renderer.setElementStyle(this.el.nativeElement.querySelector('#postcard'), 'transform', this.current_transform + translate);
  };

  addTranscript = function () {
    this.postcard.transcribed = 1;
    this.api.addTranscript(JSON.stringify(this.postcard), JSON.parse(localStorage.getItem('user')).user_id).subscribe(
      res => {
        console.log(res);
      }
    );
  };

  reportIssue = function () {
    if (!this.reported) {
      this.reported = true;
      this.reportDialog = this.dialog.open(ReportIssueComponent, {
        hasBackdrop: true
      });

      this.reportDialog.afterClosed().subscribe(
        selectedOption => {
          if (selectedOption != null) {
            // let's update the postcard
            this.postcard.flagged = 1;

            // thank the user for the report
            this.alertReport();

            // send this report to the server
            this.api.reportPostcard(this.postcard.postcard_id, this.postcard.transcript_id, JSON.parse(localStorage.getItem('user')).user_id, `${selectedOption}`).subscribe(
              res => {
                console.log(res);
              }
            );
          }
          // allow the report button to be pressed again
          this.reported = false;

          // remove the focus
          this.el.nativeElement.querySelector('.cdk-program-focused').classList.remove('cdk-program-focused');
        });
    }
  };

  updateUrl = function () {
    this.postcard.postcard_image = environment.errors.missingImageURL;
  };

  alertReport = function () {
    this.reportSnackbar.open('Thank you!', 'Dismiss', {
      duration: 1500,
    });
  };
}
